import React from 'react';
import { LISTS_INDENTATION_GROUP, LISTS_INDENTATION_GROUP_COLLAPSED, LISTS_INDENTATION_GROUP_COLLAPSED_RANK, LISTS_INDENTATION_GROUP_INLINE, LISTS_INDENTATION_GROUP_RANK, LISTS_INDENTATION_HERO_BUTTON, LISTS_INDENTATION_HERO_BUTTON_COLLAPSED } from '@atlaskit/editor-common/toolbar';
import { ListsIndentationHeroButtonCollapsed, ListsIndentationHeroButtonNew } from './ListsIndentationHeroButton';
export var getListsIndentationHeroButton = function getListsIndentationHeroButton(api) {
  return [{
    type: LISTS_INDENTATION_HERO_BUTTON.type,
    key: LISTS_INDENTATION_HERO_BUTTON.key,
    parents: [{
      type: LISTS_INDENTATION_GROUP.type,
      key: LISTS_INDENTATION_GROUP.key,
      rank: LISTS_INDENTATION_GROUP_RANK[LISTS_INDENTATION_HERO_BUTTON.key]
    }],
    component: function component(_ref) {
      var parents = _ref.parents;
      return /*#__PURE__*/React.createElement(ListsIndentationHeroButtonNew, {
        api: api,
        parents: parents
      });
    }
  }, {
    type: LISTS_INDENTATION_HERO_BUTTON_COLLAPSED.type,
    key: LISTS_INDENTATION_HERO_BUTTON_COLLAPSED.key,
    parents: [{
      type: LISTS_INDENTATION_GROUP_COLLAPSED.type,
      key: LISTS_INDENTATION_GROUP_COLLAPSED.key,
      rank: LISTS_INDENTATION_GROUP_COLLAPSED_RANK[LISTS_INDENTATION_HERO_BUTTON_COLLAPSED.key]
    }, {
      type: LISTS_INDENTATION_GROUP_INLINE.type,
      key: LISTS_INDENTATION_GROUP_INLINE.key,
      rank: LISTS_INDENTATION_GROUP_COLLAPSED_RANK[LISTS_INDENTATION_HERO_BUTTON_COLLAPSED.key]
    }],
    component: function component(_ref2) {
      var parents = _ref2.parents;
      return /*#__PURE__*/React.createElement(ListsIndentationHeroButtonCollapsed, {
        api: api,
        parents: parents
      });
    }
  }];
};